if (!customElements.get("product-metafield-tabs")) {
  customElements.define(
    "product-metafield-tabs",
    class ProductMetafieldTabs extends HTMLElement {
      constructor() {
        super();
        this.navItems = this.querySelectorAll(".product-tabs__nav-item");
        this.panes = this.querySelectorAll(".product-tabs__pane");
        this.showMoreBtns = this.querySelectorAll(".product-tabs__show-more");

        this.navItems.forEach((item) => {
          item.addEventListener("click", () => {
            const tab = item.getAttribute("data-tab");
            const isActive = item.classList.contains("active");
            const pane = this.querySelector(`#tab-${tab}`);
            const inner = pane ? pane.querySelector(".product-tabs__pane-inner") : null;
            const btn = pane ? pane.querySelector(".product-tabs__show-more") : null;

            if (isActive && inner && btn && !btn.classList.contains("hidden")) {
              // Already active — toggle content expand/collapse
              const isCollapsed = inner.classList.contains("collapsed");
              if (isCollapsed) {
                inner.classList.remove("collapsed", "has-fade");
                btn.querySelector(".btn__text").textContent = "Show Less";
                const caret = btn.querySelector(".icon-caret-down");
                if (caret) caret.classList.add("rotate-180");
              } else {
                inner.classList.add("collapsed", "has-fade");
                btn.querySelector(".btn__text").textContent = "Show More";
                const caret = btn.querySelector(".icon-caret-down");
                if (caret) caret.classList.remove("rotate-180");
              }
            } else {
              // Switch to new tab
              this.switchTab(tab);
              // Auto-expand Show More
              if (inner && btn && !btn.classList.contains("hidden")) {
                inner.classList.remove("collapsed", "has-fade");
                btn.querySelector(".btn__text").textContent = "Show Less";
                const caret = btn.querySelector(".icon-caret-down");
                if (caret) caret.classList.add("rotate-180");
              }
            }
          });
        });

        this.showMoreBtns.forEach((btn) => {
          btn.addEventListener("click", () => {
            const pane = btn.closest(".product-tabs__pane");
            const inner = pane.querySelector(".product-tabs__pane-inner");
            const isCollapsed = inner.classList.contains("collapsed");

            if (isCollapsed) {
              inner.classList.remove("collapsed");
              inner.classList.remove("has-fade");
              btn.querySelector(".btn__text").textContent = "Show Less";
              btn.querySelector(".icon-caret-down").classList.add("rotate-180");
            } else {
              inner.classList.add("collapsed");
              inner.classList.add("has-fade");
              btn.querySelector(".btn__text").textContent = "Show More";
              btn
                .querySelector(".icon-caret-down")
                .classList.remove("rotate-180");
            }
          });
        });

        // Initial check for height
        this.init();
      }

      init() {
        this.panes.forEach((pane) => {
          this.checkHeightForPane(pane);
        });
      }

      switchTab(tabId) {
        this.navItems.forEach((item) => {
          item.classList.toggle(
            "active",
            item.getAttribute("data-tab") === tabId
          );
        });

        this.panes.forEach((pane) => {
          const isActive = pane.id === `tab-${tabId}`;
          pane.classList.toggle("active", isActive);
          if (isActive) {
            this.checkHeightForPane(pane);
          }
        });
      }

      checkHeightForPane(pane) {
        const inner = pane.querySelector(".product-tabs__pane-inner");
        const btn = pane.querySelector(".product-tabs__show-more");
        if (!inner || !btn) return;

        // Reset to measure correctly
        inner.classList.remove("collapsed");
        inner.classList.remove("has-fade");

        const fullHeight = inner.scrollHeight;
        const threshold = 120; // 5 lines + buffer for paragraph margins

        if (fullHeight > threshold) {
          btn.classList.remove("hidden");
          inner.classList.add("collapsed");
          inner.classList.add("has-fade");
        } else {
          btn.classList.add("hidden");
          inner.classList.remove("collapsed");
          inner.classList.remove("has-fade");
        }
      }
    }
  );
}
